import {
  SET_METRICS_MASTER,
  SET_DIMENSIONS_MASTER,
  ADD_NEW_DASHBOARD,
  DELETE_DASHBOARD,
  UPDATE_ALL_DASHBOARD,
  SET_STAR_FOR_DASHBOARD,
  SET_MASTER_DATA,
  SET_IMPORTS_MASTER,
  UPDATE_ALL_EXCEPTION_RULES,
  UPDATE_INTTRA_CODE_IN_INQUIRY_MASTER_DATA,
  SET_USER_AGREEMENT,
  UPDATE_ONBOARDED_STATUS_IN_MASTER_DATA,
  TOGGLE_PAYMENT_FLAG,
  RESET_PREFILL_DATA,
  UPDATE_FINANCING_CTA_VISIBILITY_STATUS
} from '../actions/constants';

const defaultState: any = {
  metrics: [],
  dimensions: [],
  userData: {},
};
const changeStarStatusOfDashboard = (dashboards, id, starStatus) =>
  dashboards.map((item) => {
    if (item.id === id) {
      const temp = Object.assign({}, item);
      temp.isStarred = starStatus;
      return temp;
    }
    return item;
  });

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case SET_MASTER_DATA: {
      return {
        ...state,
        ...action.data,
      };
    }
    case SET_USER_AGREEMENT: {
      return {
        ...state,
        userData: {
          ...state.userData,
          privacy_policy_accepted: true,
        },
      };
    }
    case SET_METRICS_MASTER: {
      return {
        ...state,
        metrics: action.data,
      };
    }
    case SET_IMPORTS_MASTER: {
      return {
        ...state,
        imports: action.data
      }
    }
    case SET_DIMENSIONS_MASTER: {
      return {
        ...state,
        dimensions: action.data,
      };
    }
    case ADD_NEW_DASHBOARD: {
      return {
        ...state,
        dashboards:[
          ...state.dashboards,
          action.data,
        ],
      };
    }
    case DELETE_DASHBOARD: {
      return {
        ...state,
        dashboards: state.dashboards.filter(item => item.id !== action.dashboardId),
      };
    }
    case UPDATE_ALL_DASHBOARD: {
      return {
        ...state,
        dashboards: action.list,
      };
    }
    case UPDATE_ALL_EXCEPTION_RULES: {
      return {
        ...state,
        exceptionRules: action.list.data,
      };
    }

    case SET_STAR_FOR_DASHBOARD: {
      return {
        ...state,
        dashboards:
          changeStarStatusOfDashboard(state.dashboards, action.dashboardId, action.starStatus),
      };
    }

    case UPDATE_INTTRA_CODE_IN_INQUIRY_MASTER_DATA:
      return {
        ...state,
        inttraCode: action.data,
      };
    
    case UPDATE_ONBOARDED_STATUS_IN_MASTER_DATA:
      return {
        ...state,
        triangulation: {
          ...state.triangulation,
          onboarded: true,
        },
      };

    case TOGGLE_PAYMENT_FLAG:
      return {
        ...state,
        hasPaymentDetails: !state.hasPaymentDetails,
      };

    case RESET_PREFILL_DATA: 
      return {
        ...state,
        redirectPrefillData: undefined
      };

    case UPDATE_FINANCING_CTA_VISIBILITY_STATUS: 
      return {
        ...state,
        show_get_financing_cta: false
      };

    default: return state;
  }
}
